import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-md sticky top-0 z-50" data-id="element-258">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-259">
        <div data-id="element-260">
          <a href="/" data-id="element-261">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cnc1d1uuiBabHNzspzBg67/Logo_Promred.png" alt="Promred Logo" className="h-16 md:h-20 object-contain" data-id="element-262" />
          </a>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-263">
          <a href="/nosotros" className="text-promred-gray hover:text-promred-red font-medium transition-colors" data-id="element-264">
            Nosotros
          </a>
          <a href="/#servicios" className="text-promred-gray hover:text-promred-red font-medium transition-colors" data-id="element-265">
            Servicios
          </a>
          <a href="/#caracteristicas" className="text-promred-gray hover:text-promred-red font-medium transition-colors" data-id="element-266">
            ¿Por qué elegirnos?
          </a>
          <a href="/programas-clientes" className="text-promred-gray hover:text-promred-red font-medium transition-colors" data-id="element-267">
            Nuestros Clientes
          </a>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-promred-gray" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-268">
          {isMenuOpen ? <XIcon size={24} data-id="element-269" /> : <MenuIcon size={24} data-id="element-270" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white py-4 px-4 shadow-lg" data-id="element-271">
          <nav className="flex flex-col space-y-4" data-id="element-272">
            <a href="/nosotros" className="text-promred-gray hover:text-promred-red font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-273">
              Nosotros
            </a>
            <a href="/#servicios" className="text-promred-gray hover:text-promred-red font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-274">
              Servicios
            </a>
            <a href="/#caracteristicas" className="text-promred-gray hover:text-promred-red font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-275">
              ¿Por qué elegirnos?
            </a>
            <a href="/programas-clientes" className="text-promred-gray hover:text-promred-red font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-276">
              Nuestros Programas y Clientes
            </a>
          </nav>
        </div>}
    </header>;
};
export default Header;